import { CircleUserRound } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { NotificationBell } from '../components/NotificationBell.js';
import { RosterSyncButton } from '../components/RosterSyncButton.js';
import { UserMenu } from '../components/UserMenu.js';
import { useAuth } from '../context/AuthContext.js';
import { NavMenu } from './NavMenu.js';
import './Navbar.css';

/**
 * No bar, no sticky strip — just two floating controls anchored to the
 * viewport's top corners, so a full-bleed page (the roster hero wall) can
 * run edge to edge underneath them.
 */
export function Navbar() {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();

  return (
    <>
      <div className="navbar-float navbar-float-left">
        {/* Logged out, the roster (this page) is the only destination there
            is — the dropdown would open onto a single link back to where the
            visitor already is, so it isn't worth showing at all. The sync
            button, unlike the dropdown, is for everyone. */}
        {isAuthenticated && <NavMenu />}
        <RosterSyncButton />
      </div>
      <div className="navbar-float navbar-float-right">
        {isAuthenticated ? (
          <div className="navbar-actions-chip">
            <NotificationBell />
            <UserMenu />
          </div>
        ) : (
          <NavLink
            to="/login"
            className="btn btn-primary btn-icon navbar-login-button"
            aria-label={t('nav.login')}
            title={t('nav.login')}
          >
            <CircleUserRound size={17} />
          </NavLink>
        )}
      </div>
    </>
  );
}
